import {
    Factions,
    FeudItems,
    FeudMatchesHash,
    FeudParticipantsHash, FeudSegmentsHash, Matches,
    Rosters, Segments,
    Superstars,
    TagTeams
} from "./models.js";

function Feud() {

    // String
    const name = null;
    const description = null;
    const consequenceAppliedTo = null;
    const directFeudEvent = null;

    // Integer
    const hype = 0;
    const startMonth = null;
    const startYear = null;
    const endMonth = null;
    const endYear = null;

    // Float
    const rating = null;
    const stalenessCounter = 0;

    // Boolean
    const started = false;
    const runBlowoff = false;
    const ended = false;
    const hot = false;
    const stale = false;

    // Arrays
    const participants = [];

    // Foreign keys
    const feudItemId = null;
    const rosterId = null;

    return {
        name,
        description,
        consequenceAppliedTo,
        directFeudEvent,
        hype,
        startMonth,
        startYear,
        endMonth,
        endYear,
        rating,
        stalenessCounter,
        started,
        runBlowoff,
        ended,
        hot,
        stale,
        participants,
        feudItemId,
        rosterId,
    };
}

function getFeudRoster(feud) {
    return Rosters.find({'$loki': feud.rosterId})[0];
}

function getFeudFeudItem(feud) {
    return FeudItems.find({'$loki': feud.feudItemId})[0];
}

function addFeudSuperstars(feud, superstars) {
    let feudHashes = superstars.map(s => {
        return {feudId: feud.$loki, superstarId: s.$loki}
    });
    return FeudParticipantsHash.insert(feudHashes);
}

async function getFeudSuperstars(feud) {
    const feudHashes = await FeudParticipantsHash.find({'feudId': feud.$loki});
    const superstarIds = feudHashes.map(x => {
        return x.superstarId
    });
    if (!superstarIds[0]) {  // Not superstars feud
        return
    }
    return Superstars.find({'$loki': {'$in': superstarIds}})
}

function addFeudTagTeams(feud, tagTeams) {
    let feudHashes = tagTeams.map(s => {
        return {feudId: feud.$loki, tagTeamId: s.$loki}
    });
    return FeudParticipantsHash.insert(feudHashes);
}

async function getFeudTagTeams(feud) {
    const feudHashes = await FeudParticipantsHash.find({'feudId': feud.$loki});
    const tagTeamIds = feudHashes.map(x => {
        return x.tagTeamId
    });
    if (!tagTeamIds[0]) {
        return
    }
    return TagTeams.find({'$loki': {'$in': tagTeamIds}})
}

function addFeudFactions(feud, factions) {
    let feudHashes = factions.map(s => {
        return {feudId: feud.$loki, factionId: s.$loki}
    });
    return FeudParticipantsHash.insert(feudHashes);
}

async function getFeudFactions(feud) {
    const feudHashes = await FeudParticipantsHash.find({'feudId': feud.$loki});
    const factionIds = feudHashes.map(x => {
        return x.factionId
    });
    if (!factionIds[0]) {
        return
    }
    return Factions.find({'$loki': {'$in': factionIds}})
}

async function getFeudParticipants(feud) {
    const feudSuperstars = await getFeudSuperstars(feud);
    if (feudSuperstars) {
        return feudSuperstars
    }
    const feudTagTeams = await getFeudTagTeams(feud);
    if (feudTagTeams) {
        return feudTagTeams
    }
    const feudFactions = await getFeudFactions(feud);
    if (feudFactions) {
        return feudFactions
    }
    return [];
}

async function getFeudMatches(feud) {
    const feudHashes = await FeudMatchesHash.find({'feudId': feud.$loki});
    const matchIds = feudHashes.map(x => {
        return x.matchId
    });
    return Matches.find({'$loki': {'$in': matchIds}});
}

async function getFeudSegments(feud) {
    const feudHashes = await FeudSegmentsHash.find({'feudId': feud.$loki});
    const segmentIds = feudHashes.map(x => {
        return x.segmentId
    });
    return Segments.find({'$loki': {'$in': segmentIds}});
}

export { Feud, getFeudFeudItem, getFeudRoster, addFeudFactions, addFeudSuperstars, addFeudTagTeams, getFeudFactions,
    getFeudSuperstars, getFeudTagTeams, getFeudParticipants, getFeudMatches, getFeudSegments }
